import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=d586de96&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d586de96')) {
      api.createRecord('d586de96', component.options)
    } else {
      api.reload('d586de96', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=d586de96&", function () {
      api.rerender('d586de96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G3tkQTu53nNm/JS/offershelp.vue"
export default component.exports